import { Component, Input } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { IComponentInfo, IObservationInfo, IOutdatedAlertInfo, RULE_LEVEL } from "@comunicare/comunicare-interfaces";
import { ObservationsService } from "src/app/providers/observations.service";
import { DisplayPicturesComponent } from "../display-pictures/display-pictures.component";
import { ObservationSimplifiedAlertsHistoryModalComponent } from "../observation-simplified-alerts-history-modal/observation-simplified-alerts-history-modal.component";

@Component({
  selector: "app-observation-values-display",
  templateUrl: "./observation-values-display.component.html",
  styleUrls: ["./observation-values-display.component.scss"],
})
export class ObservationValuesDisplayComponent {
  @Input() observation: IObservationInfo;

  public RULE_LEVEL = RULE_LEVEL;
  public isToday = false;

  constructor(private dialog: MatDialog, private observationService: ObservationsService) {}

  public showPictures(component: IComponentInfo): void {
    this.dialog.open(DisplayPicturesComponent, {
      data: {
        pictures: component.valuePictures,
        title: component.name,
        disableClose: true,
      },
    });
  }

  public showGraph(component: IComponentInfo): void {
    this.observationService.showGraph(component.valueArray);
  }

  public openAlertHistory(alerts: IOutdatedAlertInfo[]): void {
    this.dialog.open(ObservationSimplifiedAlertsHistoryModalComponent, {
      data: { outdatedAlerts: alerts },
      maxWidth: 850,
    });
  }
}
